import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {ISelect} from '../../../core/model/global.interface';
import listErrors from 'src/app/core/constants/errors/generalErrors.json';

@Component({
    selector: 'app-input-select',
    templateUrl: './input-select.component.html',
    styleUrls: ['./input-select.component.css'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputSelectComponent),
        multi: true
    }]
})
export class InputSelectComponent implements ControlValueAccessor {

    listErrors = listErrors;
    options: ISelect[];
    control = new FormControl('');
    validateErrors: boolean = false;
    @Input() inputId: string;
    @Input() placeholder: string;
    @Input() toolTip: boolean = false;
    private onTouch: Function;

    writeValue(value: string): void {
        if (value) {
            this.control.setValue(value, {emitEvent: false});
        } else {
            this.control.reset('');
        }
    }

    registerOnChange(fn: (value: string) => void): void {
        this.control.valueChanges.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState(isDisabled: boolean) {
        if (isDisabled) {
            this.control.disable();
        } else {
            this.control.enable();
        }
    }

    deletePlaceholder():void{
        this.placeholder = "";
    }

    get isMandatory(): boolean {
        return !!this.control.hasError('required') && (this.control.touched || this.validateErrors);
    }

    @Input()
    set values(values: ISelect[]) {
        this.options = values;
    }

    @Input()
    set required(value: boolean) {
        if (value) {
            this.control.setValidators([Validators.required]);
            this.control.updateValueAndValidity();
        } else {
            this.control.clearValidators();
            this.control.updateValueAndValidity();
        }
    }

    @Input()
    set submit(submit) {
        this.validateErrors = submit;
    }
}
